import { render, staticRenderFns } from "./TipsZonglan.vue?vue&type=template&id=a678788c&scoped=true"
import script from "./TipsZonglan.vue?vue&type=script&lang=js"
export * from "./TipsZonglan.vue?vue&type=script&lang=js"
import style0 from "./TipsZonglan.vue?vue&type=style&index=0&id=a678788c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a678788c",
  null
  
)

export default component.exports